import Vue from 'vue'

export default {
  install() {
	Vue.prototype.$FUNC_F1000 = 'F1000';
	
	//项目台账(个人)
    Vue.prototype.$FUNC_F1100 = 'F1100';
    Vue.prototype.$FUNC_F1110 = 'F1110';
    Vue.prototype.$FUNC_F1120 = 'F1120';
    Vue.prototype.$FUNC_F1130 = 'F1130';
    //项目审核
    Vue.prototype.$FUNC_F1210 = 'F1210';
    //项目复核
    Vue.prototype.$FUNC_F1310 = 'F1310';
    //项目签发
    Vue.prototype.$FUNC_F1410 = 'F1410';
    //项目文印
    Vue.prototype.$FUNC_F1510 = 'F1510';
	//项目台账(经理)
    Vue.prototype.$FUNC_F1900 = 'F1900';
    Vue.prototype.$FUNC_F1910 = 'F1910';
    Vue.prototype.$FUNC_F1920 = 'F1920';
    Vue.prototype.$FUNC_F1930 = 'F1930';
    Vue.prototype.$FUNC_F1940 = 'F1940';
    Vue.prototype.$FUNC_F1950 = 'F1950';
    Vue.prototype.$FUNC_F1960 = 'F1960';
    Vue.prototype.$FUNC_F1970 = 'F1970';
    
	//项目台账分析
    Vue.prototype.$FUNC_F2000 = 'F2000';
    Vue.prototype.$FUNC_F2010 = 'F2010';
    Vue.prototype.$FUNC_F2020 = 'F2020';
    Vue.prototype.$FUNC_F2030 = 'F2030';
    Vue.prototype.$FUNC_F2040 = 'F2040';
    Vue.prototype.$FUNC_F2041 = 'F2041';
    Vue.prototype.$FUNC_F2050 = 'F2050';
    Vue.prototype.$FUNC_F2060 = 'F2060';
    Vue.prototype.$FUNC_F2070 = 'F2070';
    Vue.prototype.$FUNC_F2080 = 'F2080';
    Vue.prototype.$FUNC_F2090 = 'F2090';
    Vue.prototype.$FUNC_F2091 = 'F2091';
    
    //发票管理-申请开票
    Vue.prototype.$FUNC_F1610 = 'F1610';
    Vue.prototype.$FUNC_F1611 = 'F1611';
    Vue.prototype.$FUNC_F1612 = 'F1612';
    Vue.prototype.$FUNC_F1613 = 'F1613';
    Vue.prototype.$FUNC_F1614 = 'F1614';
    Vue.prototype.$FUNC_F1615 = 'F1615';
    Vue.prototype.$FUNC_F1616 = 'F1616';
    Vue.prototype.$FUNC_F1617 = 'F1617';
    Vue.prototype.$FUNC_F1618 = 'F1618';
    //发票管理-开票管理
    Vue.prototype.$FUNC_F1620 = 'F1620';
    Vue.prototype.$FUNC_F1621 = 'F1621';
    Vue.prototype.$FUNC_F1622 = 'F1622';
    Vue.prototype.$FUNC_F1623 = 'F1623';
    Vue.prototype.$FUNC_F1624 = 'F1624';
    Vue.prototype.$FUNC_F1625 = 'F1625';
    Vue.prototype.$FUNC_F1626 = 'F1626';
    //发票管理-发票抬头管理
    Vue.prototype.$FUNC_F1630 = 'F1630';
    Vue.prototype.$FUNC_F1631 = 'F1631';
    Vue.prototype.$FUNC_F1632 = 'F1632';
    Vue.prototype.$FUNC_F1633 = 'F1633';
    
    //收款管理-收款录入
    Vue.prototype.$FUNC_F1710 = 'F1710';
    Vue.prototype.$FUNC_F1711 = 'F1711';
    Vue.prototype.$FUNC_F1712 = 'F1712';
    Vue.prototype.$FUNC_F1713 = 'F1713';
    Vue.prototype.$FUNC_F1714 = 'F1714';
    Vue.prototype.$FUNC_F1715 = 'F1715';
    Vue.prototype.$FUNC_F1716 = 'F1716';
    Vue.prototype.$FUNC_F1717 = 'F1717';
    Vue.prototype.$FUNC_F1718 = 'F1718';
    //收款管理-收款确认
    Vue.prototype.$FUNC_F1720 = 'F1720';
    Vue.prototype.$FUNC_F1721 = 'F1721';
    Vue.prototype.$FUNC_F1722 = 'F1722';
    Vue.prototype.$FUNC_F1723 = 'F1723';
    Vue.prototype.$FUNC_F1724 = 'F1724';
    //收款管理-银行流水
    Vue.prototype.$FUNC_F1730 = 'F1730';
    Vue.prototype.$FUNC_F1731 = 'F1731';
    Vue.prototype.$FUNC_F1732 = 'F1732';
    Vue.prototype.$FUNC_F1733 = 'F1733';
    Vue.prototype.$FUNC_F1734 = 'F1734';
    
    //通知公告
    Vue.prototype.$FUNC_F2400 = 'F2400';
    Vue.prototype.$FUNC_F2401 = 'F2401';
    Vue.prototype.$FUNC_F2402 = 'F2402';
    Vue.prototype.$FUNC_F2403 = 'F2403';
    Vue.prototype.$FUNC_F2404 = 'F2404';
    
    //单位管理
    Vue.prototype.$FUNC_F2500 = 'F2500';
    Vue.prototype.$FUNC_F2501 = 'F2501';
    Vue.prototype.$FUNC_F2502 = 'F2502';
    Vue.prototype.$FUNC_F2503 = 'F2503';
    
    //项目归档
    Vue.prototype.$FUNC_F2610 = 'F2610';
    
    //系统管理-组织管理
    Vue.prototype.$FUNC_F9010 = 'F9010';
    Vue.prototype.$FUNC_F9011 = 'F9011';
    Vue.prototype.$FUNC_F9012 = 'F9012';
    Vue.prototype.$FUNC_F9013 = 'F9013';
    //系统管理-角色管理
    Vue.prototype.$FUNC_F9020 = 'F9020';
    Vue.prototype.$FUNC_F9021 = 'F9021';
    Vue.prototype.$FUNC_F9022 = 'F9022';
    Vue.prototype.$FUNC_F9023 = 'F9023';
    //系统管理-用户管理
    Vue.prototype.$FUNC_F9030 = 'F9030';
    Vue.prototype.$FUNC_F9031 = 'F9031';
    Vue.prototype.$FUNC_F9032 = 'F9032';
    Vue.prototype.$FUNC_F9033 = 'F9033';
    Vue.prototype.$FUNC_F9034 = 'F9034';
    //系统管理-业务来源
    Vue.prototype.$FUNC_F9040 = 'F9040';
    Vue.prototype.$FUNC_F9041 = 'F9041';
    Vue.prototype.$FUNC_F9042 = 'F9042';
    Vue.prototype.$FUNC_F9043 = 'F9043';
  }
}
